(() => {
  if (window.qeydoContactChatReady) return;
  window.qeydoContactChatReady = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.template-page-contact [data-qeydo-contact-chat]');
    if (!link) return;
    event.preventDefault();
    const api = window.ShopifyChat || window.Shopify?.chat;
    if (api && typeof api.open === 'function') { api.open(); return; }
    const host = document.querySelector('#ShopifyChat, #shopify-chat, shopify-chat, inbox-online-store-chat, [data-shopify-chat]');
    const findLauncher = (root) => {
      const button = root?.querySelector('button[aria-expanded="false"], button[aria-controls], button, [role="button"]');
      if (button) return button;
      for (const element of root?.querySelectorAll('*') || []) {
        if (element.shadowRoot) {
          const nested = findLauncher(element.shadowRoot);
          if (nested) return nested;
        }
      }
      return null;
    };
    const launcher = host && findLauncher(host.shadowRoot || host);
    if (launcher) { launcher.click(); return; }
    // Keep assistance available if Inbox is disabled or cannot expose its launcher.
    const contact = link.closest('.qc-guide').querySelector('a[href*="/pages/contact"]');
    window.location.assign(contact?.href || '/pages/contact');
  });
})();
